import { render, staticRenderFns } from "./StoryModal.vue?vue&type=template&id=77efeb6f&scoped=true&"
import script from "./StoryModal.vue?vue&type=script&lang=ts&"
export * from "./StoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./StoryModal.vue?vue&type=style&index=0&id=77efeb6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77efeb6f",
  null
  
)

export default component.exports